"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.xmlToEL = exports.elementToEL = void 0;
const xmldom_1 = require("@xmldom/xmldom");
const _1 = require(".");
const elementToEL = (el) => {
    const children = [];
    for (const node of Array.from(el.childNodes)) {
        if (node.nodeType === xmldom_1.Node.TEXT_NODE) {
            const text = (node.nodeValue || "")
                .replace(/^[ \r\n\t]+/, "")
                .replace(/[ \r\n\t]+$/, "");
            if (text) {
                children.push(text);
            }
        }
        else if (node.nodeType === xmldom_1.Node.ELEMENT_NODE) {
            children.push((0, exports.elementToEL)(node));
        }
        else {
            // console.log(node);
        }
    }
    const attr = {};
    for (const at of Array.from(el.attributes)) {
        attr[at.name] = at.value;
    }
    return new _1.EL(el.tagName, attr, children);
};
exports.elementToEL = elementToEL;
const xmlToEL = (xml) => {
    const parser = new xmldom_1.DOMParser();
    const dom = parser.parseFromString(xml, "text/xml");
    if (!dom.documentElement)
        throw new Error("never");
    return (0, exports.elementToEL)(dom.documentElement);
};
exports.xmlToEL = xmlToEL;
exports.default = exports.xmlToEL;
//# sourceMappingURL=xmlToEL.js.map